import React, { useState } from 'react';
import styles from './style.module.css';

export type RadioProps = {
  children: React.ReactNode;
  name?: string;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

const Radio = ({
  name,
  value,
  checked = true,
  disabled = false,
  children,
  onClick,
}: RadioProps): React.ReactElement => {
  const [isFocused, setIsFocused] = useState(false);

  function switchWrapper() {
    if (disabled) return styles['wrapperDisabled'];
    if (checked) return styles['wrapperChecked'];
  }

  function switchCheckmark() {
    if (checked && disabled) return styles['checkmarkCheckedDisabled'];

    if (checked) return styles['checkmarkChecked'];
  }

  function switchRadioLabel() {
    if (disabled) return styles['radio-labelDisabled'];
  }

  return (
    <div
      className={`${styles['wrapper']} ${switchWrapper()}`}
      onClick={onClick}
    >
      <input
        className={styles['custom-radio']}
        type="radio"
        value={value}
        defaultChecked={checked}
        disabled={disabled}
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={() => {
          setIsFocused(false);
        }}
      ></input>
      <div className={styles['checkmark-container']}>
        <div className={styles['focus-point']}>
          <span className={`${styles['checkmark']} ${switchCheckmark()}`}>
            <span
              className={`${styles['checkmark-focus']} ${
                isFocused && styles['focused']
              }`}
            ></span>
          </span>
        </div>
        <div className={`${styles['radio-label']} ${switchRadioLabel()}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Radio;
